import _ProfileImagesGroup from './profile-images-group';

export { default } from './profile-image';
export * from './profile-image';

export const ProfileImagesGroup = _ProfileImagesGroup;
